import PageHero from '../components/PageHero'
import Reveal from '../components/Reveal'
import { openPrivacySettings } from '../components/PrivacyPreferences'

export default function PrivacyPage() {
  return (
    <>
      <PageHero eyebrow="Privacy and storage" title="Clear choices, explained in plain language." image="/images/horse-portrait-2.webp">
        <p>This page describes the browser storage, caching, and third-party services used by this website.</p>
      </PageHero>
      <section className="section section--cream">
        <div className="container legal-content">
          <Reveal>
            <h2>Essential browser storage</h2>
            <p>The site saves your privacy preference in your browser so the preference banner does not appear on every visit. This setting supports the site experience and is not used for advertising.</p>

            <h2>Website caching</h2>
            <p>A service worker may store copies of public pages, scripts, styles, fonts, and sanctuary images on your device. This helps pages load reliably and makes repeat visits faster. Contact submissions, security-verification responses, authentication data, and payment traffic are not intentionally cached.</p>

            <h2>Optional analytics</h2>
            <p>No optional analytics or marketing trackers are currently initialized by this website. If that changes, optional tools should remain off unless the visitor’s saved preference allows them.</p>

            <h2>Contact and third-party services</h2>
            <p>The Contact form uses Google reCAPTCHA to reduce automated abuse. When the secure forms backend is configured, it validates the request and uses Microsoft Graph to deliver the message to the sanctuary. The Shop page links to the sanctuary’s external Zeffy shop. The Donate page displays the sanctuary’s Zeffy-hosted donation form inline. This website does not collect or store payment-card details.</p>

            <h2>Change your preference</h2>
            <p>You can reopen the preference panel at any time. Clearing this site’s browser storage may also clear the saved choice and cached public files.</p>
            <button className="button button--dark" type="button" onClick={openPrivacySettings}>Open privacy settings</button>
          </Reveal>
        </div>
      </section>
    </>
  )
}
